// First-run onboarding (mobile OnboardingWizard, desktop auto-tutorial with its
// "which field are you in?" screen) is for NEW customers only. An old customer
// whose profile got logged out also has "no connected profile + onboarding not
// completed", and used to land in the wizard — picking a field there allocates
// a virtual number. Keep this in sync with NEW_ACCOUNT_DAYS in
// api.fbzipper.com/lib/autoAssignVirtualNumber.js.
export const NEW_ACCOUNT_DAYS = 7

export function isNewAccount(user?: { created_at?: string | Date } | null): boolean {
  if (!user || !user.created_at) return false
  const created = new Date(user.created_at).getTime()
  if (!Number.isFinite(created)) return false
  return Date.now() - created < NEW_ACCOUNT_DAYS * 24 * 60 * 60 * 1000
}
